import { render, staticRenderFns } from "./postArticle.vue?vue&type=template&id=7cbf2ba4&scoped=true&"
import script from "./postArticle.vue?vue&type=script&lang=js&"
export * from "./postArticle.vue?vue&type=script&lang=js&"
import style0 from "./postArticle.vue?vue&type=style&index=0&id=7cbf2ba4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbf2ba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cbf2ba4')) {
      api.createRecord('7cbf2ba4', component.options)
    } else {
      api.reload('7cbf2ba4', component.options)
    }
    module.hot.accept("./postArticle.vue?vue&type=template&id=7cbf2ba4&scoped=true&", function () {
      api.rerender('7cbf2ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/postArticle.vue"
export default component.exports